import { Box, Container, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
//   import { footerContent } from "../../utils/content";
import FooterLogo from '../../../assets/images/taralLogo.png';
import Title from 'components/Title';
import { footerContent } from 'utils/content';
// const { protocols, resources, services, contactus, security_and_compliance, partners_and_affiliates, socials } = footerContent;
// const { protocols, resources, services, security_and_compliance, socials } = footerContent;
const { protocols, resources, services, security_and_compliance } = footerContent;
const LinkSection = ({ title, links }) => (
  <Stack spacing={1} textAlign={'left'}>
    <Title style={{ fontSize: '20px', fontWeight: '600', whiteSpace: 'pre' }}>{title}</Title>

    {links.map(({ title }) => (
      <Typography
        key={title}
        variant="body2"
        color="black"
        sx={{
          cursor: 'pointer',
          fontSize: '12px',
          '&:hover': {
            color: 'text.primary'
          }
        }}
      >
        {title}
      </Typography>
    ))}
  </Stack>
);
const footerMain = {
  background: 'url(/images/footer/footerbg.png)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  paddingBottom: '50px'
};

const Footer = () => {
  return (
    <Box sx={footerMain}>
      {/* <Box sx={{ mb: 10 }} /> */}
      <Container maxWidth="xl">
        <Grid container spacing={8}>
          {/* Links */}
          <Grid item xs={12} md={6} lg={4} xl={4}>
            <Box>
              <img style={{ width: '253px', height: '94px' }} src={FooterLogo} alt="footerlogo" />
              <Title style={{ padding: '10px 0px', fontSize: '15px' }}>
                Taral&apos;s innovative halving-based POS ensures token scarcity and value preservation. With regular halving every four
                years, our network maintains economic stability while incentivizing long-term investment. Additionally, our robust burn
                mechanism systematically reduces the total token supply by permanently removing a portion of tokens from circulation. This
                dual approach of halving and burning not only enhances scarcity but also supports sustainable value growth, creating a
                balanced and thriving economic ecosystem.
              </Title>
              {/* <LinkSection {...terms} /> */}
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={8} xl={8} display="flex" justifyContent="end" style={{ position: 'relative' }}>
            <Grid container spacing={2} display="flex" sx={{ justifyContent: { xs: 'start', md: 'flex-end' }, mr: { xs: 0, md: 5 } }}>
              <Grid
                item
                xs={6}
                sm={4}
                lg={2}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                <LinkSection {...protocols} />
              </Grid>

              <Grid
                item
                xs={6}
                sm={4}
                lg={3}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                <LinkSection {...resources} />
              </Grid>

              {/* <Grid item xs={6} sm={3} md={6} lg={2}>
                <LinkSection {...services} />
              </Grid>

              <Grid item xs={6} sm={3} md={6} lg={2}>
                <LinkSection {...developers} />
              </Grid> */}
              <Grid
                item
                xs={6}
                sm={4}
                lg={3}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                <LinkSection {...services} />
              </Grid>
              <Grid
                item
                xs={6}
                sm={4}
                lg={3}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' },
                  ml: { xs: 0, md: 5 }
                }}
              >
                <LinkSection {...security_and_compliance} />
              </Grid>
              {/* <Grid
                item
                xs={6}
                sm={4}
                lg={2}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                <LinkSection {...partners_and_affiliates} />
              </Grid>
              <Grid
                item
                xs={6}
                sm={4}
                lg={2}
                container
                sx={{
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                <LinkSection {...contactus} />
              </Grid> */}
            </Grid>
          </Grid>

          {/* Subscribe */}

          {/* <Grid item xs={12} md={12} lg={12} xl={12}>
            <Stack>
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="end" flexWrap="wrap">
                {socials.map((item, i) => (
                  <IconButton key={i} style={{ color: 'black' }}>
                    <item.icon />
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Grid> */}
        </Grid>

        {/* <Grid container justifyContent={'center'} alignItems={'center'} sx={{ mt: 6 }}>
          {socials.map((item, i) => (
            <IconButton
              key={i}
              style={{ color: 'black' }}
              onClick={() => {
                window.open(item.link, '_blank');
              }}
            >
              <item.icon />
            </IconButton>
          ))}
        </Grid> */}
      </Container>
    </Box>
  );
};

export default Footer;
